import {useQuery} from "@tanstack/react-query";

import {panicAlertsService} from "../services";

type UsePanicButtonConfigOptions = {
  /** When false, skips `GET /panic-button/config` entirely (e.g. company disabled via `/me`). */
  enabled?: boolean;
};

export function usePanicButtonConfig(
  propertyId?: number,
  {enabled = false}: UsePanicButtonConfigOptions = {},
) {
  const query = useQuery({
    queryKey: ["panic-button-config", propertyId ?? null],
    queryFn: () => panicAlertsService.getConfig(propertyId),
    enabled,
    retry: false,
  });

  return {
    config: query.data,
    isPending: query.isPending,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  };
}
